// Passcodes the customer typed for private classes/areas, kept in memory only
// (never persisted) so the booking request can carry them as `password`.
const passcodes = new Map<string, string>()

export const setPrivatePasscode = (entityId: string, code: string) => {
  if (entityId && code) {
    passcodes.set(entityId, code)
  }
}

export const getPrivatePasscodeData = (entityIds: (string | null | undefined)[]): {password?: string} => {
  for (const id of entityIds) {
    const code = id ? passcodes.get(id) : undefined
    if (code) {
      return {password: code}
    }
  }
  return {}
}
